import type { AccountingPayment } from './accounting-payment.type.ts';
export interface AccountingPaymentExtension extends AccountingPayment {}
export class AccountingPaymentExtension {
  get isCreated() {
    return this.state === 'CREATED';
  }
}

const Registration = {
  kind: 'object',
  name: 'accounting-payment',
  features: AccountingPaymentExtension,
};
export default Registration;
